// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"978a5b69","431":"a5ee5fcd","507":"f8957ce7","714":"7d2a9680","787":"b0c039d5","880":"bb725058","912":"98c710df"}[chunkId] + ".chunk.js";
};